export namespace ArrayUtils {
  export function uniqueArray<T>(array: T[]): T[] {
    return Array.from(new Set(array));
  }

  export function uniqueArrayBy<T>(array: T[], keySelector: (item: T) => any): T[] {
    const seen = new Map<any, T>();

    for (const item of array) {
      let key = keySelector(item);
      if (!seen.has(key)) {
        seen.set(key, item);
      }
    }

    return Array.from(seen.values());
  }
}
